module.exports = __webpack_public_path__ + "img/emotional.e5007627.jpg";